import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { useAppStore } from "../../store/appStore";

const Options = () => {
	const displayMode = useAppStore((state) => state.top14VoteDisplayMode);
	const setDisplayMode = useAppStore((state) => state.setTop14VoteDisplayMode);

	const handleChange = (event) => {
		if (event.target.name === "displayMode") {
			setDisplayMode(event.target.value);
		}
	};

	return (
		<List>
			<ListItem
				sx={{
					pb: 2,
				}}
			>
				<FormControl size="small" fullWidth>
					<InputLabel>排版</InputLabel>
					<Select
						name="displayMode"
						value={displayMode}
						label="排版"
						onChange={handleChange}
					>
						<MenuItem value="3_4">3:4</MenuItem>
						<MenuItem value="4_3">4:3</MenuItem>
						<MenuItem value="4_4">4:4</MenuItem>
					</Select>
				</FormControl>
			</ListItem>
		</List>
	);
};

export default Options;
